export enum Interval {
  DAY = 'day',
  MONTH = 'month',
}

export type DaysAndInterval = [7, Interval.DAY] | [30, Interval.DAY] | [6, Interval.MONTH];

export const getDatesFromDaysAndInterval = (daysAndInterval: DaysAndInterval): { startDate: string; endDate: string } => {
  const endDate = new Date();
  endDate.setDate(endDate.getDate() - 1);
  const startDate = new Date(endDate);
  if (daysAndInterval[1] === Interval.DAY) {
    // NOTE: setting date to a negative value goes into the previous month correctly
    startDate.setDate(endDate.getDate() - daysAndInterval[0] + 1);
  } else {
    startDate.setMonth(endDate.getMonth() - daysAndInterval[0] + 1);
    startDate.setDate(1);
  }
  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
  };
};

export const getIntervalFromDaysAndInterval = (daysAndInterval: DaysAndInterval): Interval => {
  return daysAndInterval[1];
};
